export default __webpack_public_path__ + "static/media/step2.2b9d4681.webp";